import {Component} from "@/event/calendar/dom/Component.ts";
import {GutterSized} from "@/event/calendar/days/GutterSized.ts";
import type {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {Range, Rect} from "@/event/calendar/Shapes.ts";
import {GUTTER_FONT_SIZE, GUTTER_PADDING} from "@/event/calendar/Constants.ts";
import {measure} from "@/bpm/canvas/CanvasUtils.ts";
import {CalendarView} from "@/event/calendar/CalendarModel.ts";
import {calcTimeGrid} from "@/event/calendar/days/DaysTimedBody.ts";

export class DaysTimedHeader extends Component implements GutterSized {
	public gutterWidth:number;
	private view: CalendarView;
	private dayHeight:number;

	constructor(view: CalendarView) {
		super();
		this.view = view;
	}

	calcMinGutter(dc: DrawingContext):number {
		const fontFamily = dc.style.getPropertyValue("--font");
		dc.ctx.font = GUTTER_FONT_SIZE + "px " + fontFamily;
		const title = "00:00";
		const m = measure(dc.ctx, title);

		return m.width + 2 * GUTTER_PADDING + 1;	// text + padding + border
	}

	protected drawBackground(dc: DrawingContext, area: Rect) {
		dc.ctx.fillStyle = dc.style.getPropertyValue("--cal-header-bg");
		dc.ctx.fillRect(area.x, area.y, area.width, area.height);
	}

	protected drawContent(dc: DrawingContext, area: Rect) {
		const fontFamily = dc.style.getPropertyValue("--font");
		const headerFg = dc.style.getPropertyValue("--cal-header-fg");
		dc.ctx.font = GUTTER_FONT_SIZE + "px " + fontFamily;
		dc.ctx.textAlign = "right";

		const starth = typeof this.view.startHour === "number" ? this.view.startHour : 8;
		const endh = typeof this.view.endHour === "number" ? this.view.endHour : 18;

		const hour = calcTimeGrid(this.view, this.height);
		for (let h = 0; h < 24; h++) {
			if (h > 0) {
				const y = this.y + hour.height * h + 4;
				let workHours = !(h < starth || h > endh);
				dc.ctx.fillStyle = workHours ? headerFg : headerFg+"66";
				dc.ctx.fillText(formatTimeStamp(h, 0), this.gutterWidth - GUTTER_PADDING - 1, y);
			}
		}
		this.dayHeight = 24 * hour.height;
	}

	protected drawBorder(dc: DrawingContext, area: Rect) {
		dc.ctx.strokeStyle = dc.style.getPropertyValue("--cal-header-separ");
		dc.ctx.beginPath();
		dc.ctx.moveTo(this.width - 0.5, area.y);
		dc.ctx.lineTo(this.width - 0.5, area.y + area.height);
		dc.ctx.stroke();
	}


	verticalScrollRange(): Range {
		return {
			min: 0,
			max: Math.max(this.dayHeight - this.height, 0)
		};
	}
}

function formatTimeStamp(hour:number, minute:number):string {
	let h = hour.toString();
	let m = minute.toString();
	if (m.length === 1) m = "0" + m;
	return h + ":" + m;
}